import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { SERVICE_LABEL_WHOLESALER } from '../Helper/constants.js'
import {
  findFundById,
  findLiteratureById,
  getWholesalerLabel,
  setSelectedFund,
} from '../Helper/helper.js'

import SuccessMessage from '../Modules/SuccessMessage.jsx'

function AddProductModal(props) {
  const _searchText = ''

  const [productTypes, setProductTypes] = useState(props.productTypes)
  const [assetClasses, setAssetClasses] = useState(props.assetClasses)
  const [searchText, setSearchText] = useState(_searchText)
  const [successMessage, setSucessMessage] = useState(false)

  const {
    addToServiceQueue,
    updateFunds,
    funds,
    wholesalerLabels,
    userSubscriptionProfile,
    handleCloseModalClick,
  } = props

  const getClonedFunds = () => {
    return JSON.parse(JSON.stringify(funds))
  }

  const handleAddProductClick = (event) => {
    const _funds = getClonedFunds()

    setSelectedFund(_funds, event.target.value)

    updateFunds(_funds)

    setSucessMessage(false)
  }

  const handleCancelSelectionClick = () => {
    const _funds = getClonedFunds()

    setSelectedFund(_funds, '')

    _funds &&
      _funds.forEach((fund) => {
        fund.selected = false

        fund.activeLiterature &&
          fund.activeLiterature.forEach((doc) => {
            doc.preSelected = doc.selected
          })

        // then re-preselect (worst... feature... ever...)
        const hasAnythingPreselected = fund.activeLiterature.find(
          (doc) => doc.preSelected
        )
        if (!hasAnythingPreselected && fund.activeLiterature.length > 0) {
          fund.activeLiterature[0].preSelected = true
        }
      })

    updateFunds(_funds)
  }

  const handleRemoveProductClick = (event) => {
    const fundId = event.target.value

    const _funds = getClonedFunds()

    const fund = findFundById(_funds, fundId)
    fund.selected = false

    const selectedLiterature = []
    fund.activeLiterature &&
      fund.activeLiterature.forEach((doc) => {
        if (doc.selected) {
          doc.selected = false
          doc.preSelected = false
          selectedLiterature.push(doc)
        }
      })

    addToServiceQueue(selectedLiterature)

    updateFunds(_funds)
  }
  const handleLocalCloseModalButtonClick = (event) => {
    handleCancelSelectionClick()

    handleCloseModalClick && handleCloseModalClick(event)
  }

  const handleFundLiteratureCheckboxClick = (event) => {
    const fundId = event.target.dataset.fundId
    const docId = event.target.value

    const _funds = getClonedFunds()

    const fund = findFundById(_funds, fundId)

    const doc = findLiteratureById(fund.activeLiterature, docId)

    doc.preSelected = event.target.checked

    updateFunds(_funds)
  }

  const handleSubcribeClick = (event) => {
    const fundId = event.target.value

    const _funds = getClonedFunds()

    const fund = findFundById(_funds, fundId)

    const selectedLiterature = []

    fund.activeLiterature &&
      fund.activeLiterature.forEach((doc) => {
        if (doc.selected !== doc.preSelected) {
          doc.selected = doc.preSelected
          selectedLiterature.push(doc)
        }
      })

    addToServiceQueue(selectedLiterature)

    updateFunds(_funds)
    setSucessMessage(true)
  }

  const handleProductTypeDropdownChange = (event) => {
    const _productTypes = [...productTypes]
    setSelectedProductType(_productTypes, event.target.value)
    setProductTypes(_productTypes)
  }

  const handleAssetClassFilterClick = (event) => {
    const _assetClasses = [...assetClasses]
    const selectedAssetClass = event.target.dataset.assetClass
    setSelectedAssetClass(_assetClasses, selectedAssetClass)
    setAssetClasses(_assetClasses)
  }

  const handleAssetClassFilterChange = (event) => {
    const _assetClasses = [...assetClasses]
    const selectedAssetClass = event.target.value
    _assetClasses.forEach((assetClass) => {
      assetClass.selected = false
    })
    if (selectedAssetClass !== 'all') {
      setSelectedAssetClass(_assetClasses, selectedAssetClass)
    }

    setAssetClasses(_assetClasses)
  }

  const handleSearchTextInputChange = (event) => {
    const _searchValue = event.target.value
    setSearchText(_searchValue)
  }

  const handleSearchTextInputClear = () => {
    setSearchText('')
  }

  const getProductTypeLabel = (productTypeKey) => {
    let label = null
    productTypes.map((productType) => {
      if (productType.key === productTypeKey) {
        label = productType.label
      }
    })
    return label
  }

  const getAssetClassLabel = (assetClassKey) => {
    let label = null
    assetClasses.map((assetClass) => {
      if (assetClass.key === assetClassKey) {
        label = '| ' + assetClass.label
      }
    })
    return label
  }

  const getViewableFunds = () => {
    return funds.filter((fund) => {
      // product dropdown
      let foundProductType = false

      productTypes &&
        productTypes.forEach((productType) => {
          if (
            (productType.selected && productType.key === fund.productType) ||
            (productType.key === 'all' && productType.selected)
          ) {
            foundProductType = true
          }
        })

      // asset classes
      let foundAssetClass = true

      // if none are selected, its always true
      // so if some are selected mark it false
      assetClasses &&
        assetClasses.forEach((assetClass) => {
          if (assetClass.selected) {
            foundAssetClass = false
          }
        })

      assetClasses.forEach((assetClass) => {
        if (assetClass.selected && fund.assetClass === assetClass.key) {
          foundAssetClass = true
        }
      })

      // text search
      let foundSearchText = searchText.length <= 0
      const caseAgnosticSearchText = searchText.toLowerCase()

      const fundName = fund.name.toLowerCase()
      const fundAssetClass = fund.assetClass.toLowerCase()
      const fundProductType = fund.productType.toLowerCase()

      foundSearchText =
        foundSearchText || fundName.indexOf(caseAgnosticSearchText) >= 0
      foundSearchText =
        foundSearchText || fundAssetClass.indexOf(caseAgnosticSearchText) >= 0
      foundSearchText =
        foundSearchText || fundProductType.indexOf(caseAgnosticSearchText) >= 0

      return foundProductType && foundAssetClass && foundSearchText
    })
  }

  const handleMobileFilterClick = () => {
    document
      .getElementById('Mobile-filter-toggle')
      .classList.toggle('is-expanded')
    document.getElementById('Display-filter').classList.toggle('u-sm-hidden')
    document.getElementById('Filter-by-mobile').classList.toggle('u-sm-hidden')
    document.getElementById('Display-filter').classList.toggle('u-md-hidden')
    document.getElementById('Filter-by-mobile').classList.toggle('u-md-hidden')
  }

  return (
    <div
      id="Add-product-modal"
      className="Modal u-overflowHidden u-animFadeInUp"
      data-analytics="cesc-add-product-modal"
    >
      <section className="Modal-window">
        <div className="Modal-content u-padding0 u-overflowHidden">
          <div className="Grid">
            <div className="u-lg-size4of12 u-sm-sizeFull u-bgColorBrandDark">
              {/* MOBILE AND TABLET SEARCH */}
              <div className="Grid u-bgColorBrandDark u-lg-hidden u-paddingHoriz2gu u-paddingTop2gu">
                <div className="u-flex">
                  <label htmlFor="input-name" className="u-flexGrow1">
                    <h4 className="u-textColorWhite u-textReversed u-paddingTop3gu">
                      Find a product:
                    </h4>
                  </label>
                  <button
                    onClick={handleLocalCloseModalButtonClick}
                    className="u-flexJustifyEnd u-textColorWhite u-textReversed u-paddingHoriz1gu u-paddingVert0 u-marginBottom1gu"
                    aria-label="Close Modal"
                  >
                    ×
                  </button>
                </div>
                <div className="u-sizeFull u-flex u-flexAlignSelfCenter">
                  <div className="Input-group u-flex u-flexGrow1">
                    <input
                      type="text"
                      id="fund-search-input-mobile"
                      value={searchText}
                      onChange={handleSearchTextInputChange}
                      className="Input Input--withIcon Input--withIconLeft u-border0 u-textNoTransform u-textSizeMsrp2 u-paddingVert3gu u-textSecondary"
                      name="input-name"
                      placeholder="Search..."
                    />
                    <span
                      className="Input-icon Icon--before Icon--cti u-textColorBrand"
                      data-icon="&#xf122;"
                    ></span>
                    <button
                      className="Button Button--primary Button--reversed u-flexJustifyEnd "
                      onClick={handleSearchTextInputClear}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>

              <div className="Grid">
                <div
                  id="Display-filter"
                  className="Display-dropdown u-sizeFull u-flex u-flexAlignItemsEnd u-paddingHoriz3gu u-paddingVert2gu u-sm-marginBottom1gu u-md-marginBottom1gu u-overflowHidden"
                >
                  <label
                    className="Dropdown-label Dropdown-label--reversed u-paddingRight2gu"
                    data-collapsible="true"
                    htmlFor="dropdown-menu"
                  >
                    <h2 className="u-textColorWhite u-sm-marginRight3gu u-md-marginRight3gu">
                      Display:
                    </h2>
                  </label>

                  <div className="Dropdown Dropdown--reversed u-flexGrow1 fund-className-dropdown">
                    <select
                      id="dropdown-menu"
                      value={
                        productTypes.find((productType) => productType.selected)
                          .key
                      }
                      onChange={handleProductTypeDropdownChange}
                      className="Dropdown-menu u-paddingVert2gu"
                      tabIndex="0"
                    >
                      {productTypes.map((productType) => {
                        return (
                          <option key={productType.key} value={productType.key}>
                            {productType.label}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </div>

                <hr className="Rule u-textColorBrandLight u-sm-hidden u-md-hidden" />

                <div className="u-sizeFull u-bgColorBrandDark u-textColorWhite">
                  {/* DESKTOP FILTERS */}
                  <label
                    className="Form-label u-inlineBlock u-sm-hidden u-md-hidden"
                    htmlFor="Filter-by"
                  >
                    <h2 className="u-textColorWhite u-marginRight3gu u-marginLeft3gu u-marginVert3gu">
                      Filter by:
                    </h2>
                  </label>

                  <div id="Filter-by" className="u-md-hidden u-sm-hidden">
                    <ul
                      id="Filter-list"
                      className="u-overflow u-textSecondary u-paddingTop1gu u-paddingBottom3gu u-paddingHoriz3gu"
                    >
                      {assetClasses.map((assetClass) => {
                        return (
                          <>
                            {/* JSX-a11y refactor: update li to use button element for better accessibility -- CTINEXT-4686 */}
                            <li
                              key={assetClass.key}
                              className="u-flex u-marginBottom4gu"
                              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- CTINEXT-4686
                              tabIndex="0"
                            >
                              <hr
                                className={`Bullet Bullet--rect u-flexNone u-marginRight2gu ${getColorByName(
                                  assetClass.label
                                )}`}
                                role="presentation"
                              />
                              {/* eslint-disable-next-line */}
                              <h4
                                onClick={handleAssetClassFilterClick}
                                data-asset-class={assetClass.key}
                                className="u-flexGrow1 u-flexAlignSelfCenter u-textColorWhite u-textSecondary"
                              >
                                {assetClass.label}
                              </h4>
                              {assetClass.selected ? (
                                <span className="Icon Icon--after u-flexJustifyEnd u-flexAlignSelfCenter">
                                  {' '}
                                  
                                </span>
                              ) : (
                                ''
                              )}
                            </li>
                          </>
                        )
                      })}
                    </ul>
                  </div>

                  {/* MOBILE AND TABLET FILTERS */}
                  <div id="Filter-by-mobile" className="u-flex u-alignItemsEnd">
                    <label
                      className="Form-label u-inlineBlock u-lg-hidden u-marginBottom0 u-marginTop2gu"
                      htmlFor="Filter-by-dropdown"
                    >
                      <h2 className="u-textColorWhite u-marginHoriz3gu">
                        Filter by:
                      </h2>
                    </label>
                    <div className="Dropdown Dropdown--reversed u-inlineBlock u-flexGrow1 u-sm-marginRight3gu u-md-marginRight3gu u-lg-hidden u-overflowHidden">
                      <select
                        onChange={handleAssetClassFilterChange}
                        className="Dropdown-menu u-paddingVert2gu"
                        id="Filter-by-dropdown"
                      >
                        <option value="all" key="all" data-asset-class="all">
                          All Asset Classes
                        </option>
                        {assetClasses.map((assetClass) => {
                          return (
                            <option
                              value={assetClass.key}
                              key={assetClass.key}
                              data-asset-class={assetClass.key}
                            >
                              {assetClass.label}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <button
                  onClick={handleMobileFilterClick}
                  id="Mobile-filter-toggle"
                  className="Button Button--icon Button--expandable is-expanded u-textColorWhite u-textSecondary u-padding0 u-marginVert2gu u-textSizeMsr u-lg-hidden"
                  data-tracking="icon"
                >
                  <span className="Icon--material">arrow_drop_down</span>Filter
                  results
                </button>

                <hr className="Rule u-textColorBrandLight u-lg-hidden" />
              </div>
            </div>

            <div className="u-size8of12 u-sm-sizeFull u-md-sizeFull">
              {/* DESKTOP SEARCH */}
              <header className="Modal-header u-padding0 u-border0">
                <div className="Grid u-sm-hidden u-md-hidden u-paddingVert1gu u-paddingLeft1gu">
                  <div className="u-sizeFull u-flex u-flexAlignSelfCenter">
                    <label htmlFor="input-name" className="u-hiddenVisually">
                      Find a product
                    </label>
                    <div className="Input-group u-flex u-flexGrow1">
                      <input
                        type="text"
                        id="fund-search-input"
                        onChange={handleSearchTextInputChange}
                        className="Input Input--withIcon Input--withIconLeft u-border0 u-textSizeMsrp2 u-paddingVert3gu u-textSecondary u-textNoTransform"
                        name="input-name"
                        placeholder="Find a product"
                      />
                      <span
                        className="Input-icon Icon--before Icon--cti u-textColorBrand"
                        data-icon="&#xf122;"
                      ></span>
                    </div>
                    <button
                      onClick={handleLocalCloseModalButtonClick}
                      className="Modal-icon u-flexJustifyEnd u-bgColorWhite"
                    >
                      <span className="u-hiddenVisually">
                        Close this dialog
                      </span>
                    </button>
                  </div>
                </div>
              </header>

              <hr className="Rule u-textColorBrandLight u-sm-hidden u-md-hidden" />

              <div className="u-sm-sizeFull u-md-sizeFull">
                <div className="Grid">
                  <div className="u-sizeFull u-decoBackgroundWhite u-overflowY">
                    <div id="Product-results" className="u-posRelative">
                      <ul className="js-fund-literature-docs u-overflow">
                        {getViewableFunds().length > 0 &&
                          getViewableFunds()
                            .sort((a, b) =>
                              (a.name || '').localeCompare(b.name || '', 'en', {
                                sensitivity: 'base',
                              })
                            )
                            .map((fund, index) => {
                              const {
                                selected,
                                id,
                                name,
                                productType,
                                assetClass,
                              } = fund
                              const productLabel =
                                getProductTypeLabel(productType)
                              const activeLiterature = fund.activeLiterature

                              return (
                                <React.Fragment
                                  key={'productSubscription' + index}
                                >
                                  {selected ? (
                                    <li
                                      className="u-flex u-flexCol u-margin0 u-paddingVert3gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0"
                                      data-analytics="cesc-add-product-wrapper"
                                    >
                                      <div className="u-paddingHoriz3gu">
                                        {successMessage && <SuccessMessage />}
                                      </div>
                                      <div className="u-flex u-paddingTop1gu u-paddingHoriz3gu u-marginBottom3gu">
                                        <div className="u-flexGrow1">
                                          <h4>{name}</h4>
                                          <p>
                                            {productLabel}{' '}
                                            {getAssetClassLabel(assetClass)}
                                          </p>
                                        </div>
                                        {successMessage && (
                                          <div className="u-flexJustifyEnd u-sm-flexNone">
                                            <button
                                              value={id}
                                              onClick={handleRemoveProductClick}
                                              className="js-remove-product-button Button Button--tertiary u-textNoTransform"
                                              data-analytics="cesc-remove"
                                            >
                                              Remove Product
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                      <div className="Grid u-paddingHoriz3gu">
                                        {activeLiterature.map((doc) => {
                                          const wholesalerLabel =
                                            getWholesalerLabel(
                                              wholesalerLabels,
                                              doc.wholesalerLabel
                                            )
                                          return (
                                            <div
                                              key={'keydoc-' + doc.id}
                                              className="u-lg-size6of12 u-md-size6of12 u-sm-sizeFull u-marginBottom3gu u-flexInline"
                                            >
                                              <input
                                                disabled={successMessage}
                                                onChange={
                                                  handleFundLiteratureCheckboxClick
                                                }
                                                checked={doc.preSelected}
                                                id={'literature-' + doc.id}
                                                value={doc.id}
                                                data-fund-id={fund.id}
                                                type="checkbox"
                                                className="Subscription-checkbox"
                                                data-analytics="cesc-subscribe-checkbox"
                                              ></input>
                                              <label
                                                htmlFor={'literature-' + doc.id}
                                              >
                                                <p className="u-marginLeft1gu u-textSecondary">
                                                  {doc.name}
                                                </p>
                                              </label>
                                              {userSubscriptionProfile.role ===
                                                SERVICE_LABEL_WHOLESALER &&
                                                doc.wholesalerLabel &&
                                                wholesalerLabel && (
                                                  <div className="From-you u-marginLeft1gu u-marginBottom2gu u-inlineBlock u-bgColorLight u-paddingHoriz2gu u-textNormal">
                                                    <div className="u-textSizeMsrm1 u-textNoWrap">
                                                      {wholesalerLabel}
                                                    </div>
                                                  </div>
                                                )}
                                            </div>
                                          )
                                        })}
                                      </div>
                                      {!successMessage && (
                                        <div className="u-paddingHoriz3gu">
                                          <button
                                            onClick={handleSubcribeClick}
                                            value={fund.id}
                                            className="js-subscribe-button Button Button--secondary u-marginRight1gu u-textNoTransform"
                                            data-analytics="cesc-add-product-confirm"
                                          >
                                            Subscribe
                                          </button>
                                          <button
                                            onClick={handleCancelSelectionClick}
                                            className="Button Button--tertiary u-textNoTransform"
                                            data-analytics="cesc-add-product-cancel"
                                          >
                                            Cancel
                                          </button>
                                        </div>
                                      )}
                                    </li>
                                  ) : (
                                    <li
                                      className="u-flex u-margin0 u-paddingVert3gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0 u-sm-flexWrap"
                                      data-analytics="cesc-add-product-wrapper"
                                    >
                                      <div className="u-flexGrow1 u-paddingTop1gu u-paddingHoriz3gu">
                                        <h4>{name}</h4>
                                        <p>
                                          {productLabel}{' '}
                                          {getAssetClassLabel(assetClass)}
                                        </p>
                                      </div>
                                      <div className="u-flexJustifyEnd u-sm-flexNone">
                                        <button
                                          value={id}
                                          onClick={handleAddProductClick}
                                          className="Button Button--tertiary u-marginRight1gu u-textNoTransform u-textKernDefault"
                                          data-tracking="secondary"
                                        >
                                          Add Product
                                        </button>
                                      </div>
                                    </li>
                                  )}
                                </React.Fragment>
                              )
                            })}

                        {getViewableFunds().length <= 0 && (
                          <li>
                            <div className="u-paddingTop1gu u-paddingHoriz3gu u-marginBottom3gu">
                              <p className="u-padding3gu">
                                No matching funds found.
                              </p>
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

function getColorByName(filterName) {
  let colorClass = ''
  switch (filterName) {
    case 'Domestic Equity':
    case 'International Equity':
    case 'Global/International Equity':
    case 'Sector Equity/Specialty':
      colorClass = 'u-textColorTeal'
      break

    case 'Asset Allocation / Alternative':
    case 'Asset Allocation/Alternative':
    case 'Asset Allocation':
    case 'Alternative':
      colorClass = 'u-textColorCher'
      break

    case 'Taxable Fixed Income':
    case 'Tax-Exempt Fixed Income':
    case 'Money Market':
      colorClass = 'u-textColorGreen'
      break

    default:
      colorClass = 'u-textColorTeal'
  }

  return colorClass
}

function setSelectedProductType(productTypes, key) {
  productTypes &&
    productTypes.forEach((productType) => {
      productType.selected = productType.key === key
    })
}

function setSelectedAssetClass(assetClasses, key) {
  assetClasses &&
    assetClasses.forEach((assetClass) => {
      if (assetClass.key === key) {
        assetClass.selected = !assetClass.selected
      }
    })
}

AddProductModal.propTypes = {
  funds: PropTypes.array.isRequired,
  assetClasses: PropTypes.array.isRequired,
  productTypes: PropTypes.array.isRequired,
  wholesalerLabels: PropTypes.array.isRequired,
  userSubscriptionProfile: PropTypes.object.isRequired,
  addToServiceQueue: PropTypes.func.isRequired,
  handleCloseModalClick: PropTypes.func.isRequired,
  updateFunds: PropTypes.func.isRequired,
}

export default AddProductModal
